import * as React from "react";
import * as _ from "lodash";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { PrimaryButton } from "../../components/Buttons";
import { FormProvider, useForm } from "react-hook-form";
import { TextInput } from "../../components/forms/inputs/TextInput";

interface OwnProps {
  onSubmit: Function;
  onReset: Function;
  currentFilters: any;
}

export const PromotionCodeListFilters: React.FC<OwnProps> = (props) => {
  const methods = useForm({
    defaultValues: {
      ...props.currentFilters,
    },
  });
  const handleSubmit = (values: { [key: string]: any }) => {
    props.onSubmit(_.omitBy(values, (x) => x === ""));
  };

  return (
    /* @ts-ignore */
    <FormProvider {...methods}>
      <form className="card" onSubmit={methods.handleSubmit(handleSubmit)}>
        <div className="card-header border-bottom-0 mt-4 justify-content-between">
          <StyledText
            color={colors.textPrimary}
            className="bodyHeaderOneSemi card-title"
          >
            Search in promotion codes list
          </StyledText>
        </div>
        <div className="card-body">
          <TextInput name="filterByCode" label="Code" />
        </div>
        <div className="card-footer d-flex pt-0 border-top-0 justify-content-between">
          <PrimaryButton
            backgroundColor={colors.transparent}
            hoverColor={colors.ctaLight}
            color={colors.ctaMain}
            type="reset"
            onClick={(e) => {
              methods.reset();
              props.onReset(e);
            }}
          >
            Reset
          </PrimaryButton>
          <PrimaryButton
            backgroundColor={colors.ctaMain}
            hoverColor={colors.ctaSecondaryOne}
            color={colors.white}
            type="submit"
          >
            Search
          </PrimaryButton>
        </div>
      </form>
    </FormProvider>
  );
};

export default PromotionCodeListFilters;
